/**
 * Remove consecutive duplicate points from an array of coordinates.
 * @param points - Array of coordinates in the format [x0, y0, x1, y1, ...]
 * @returns Array of coordinates with consecutive duplicates removed
 */
export function filterDuplicatePoints(points: number[]): number[] {
  if (points.length < 4) return points;

  const filtered: number[] = [points[0], points[1]];

  for (let i = 2; i < points.length; i += 2) {
    const prevX = filtered[filtered.length - 2];
    const prevY = filtered[filtered.length - 1];
    const currX = points[i];
    const currY = points[i + 1];

    if (currX !== prevX || currY !== prevY) {
      filtered.push(currX, currY);
    }
  }

  return filtered;
}
